<template>
  <div class="page-deliver-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">報表統計</div>
      <div class="breadcrumb-item">已入庫報表</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="date"
            size="small"
            clearable
            placeholder="珠海倉庫入開始日期"
            v-model="form.start_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="date"
            size="small"
            clearable
            placeholder="珠海倉庫入库結束日期"
            v-model="form.end_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="handleExport">導出</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        size="small"
        border
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      pageInput: "", //输入的页码
      form: {
        start_time: "",
        end_time: "",
        // end_time: this.getselectdate(),
      },
      isSubmiting: false,
      table: {
        column: [
          {
            title: "单号",
            key: "odd_numbers",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "金额",
            key: "amount",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "重量",
            key: "weight",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "入库时间",
            key: "in_time",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
        ],
        data: [],
      },
    };
  },
  methods: {
    getselectdate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + "-" + month + "-" + strDate;
      return currentdate;
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    handleExport() {
      let token = localStorage.getItem("jyb_token");
      let form = this.form;
      let params = {
        Authorization: token,
        offset: (this.pageIndex - 1) * this.curPageSize,
        limit: this.curPageSize,
        start_time: this.$Utils.formatDate(form.start_time),
        end_time: this.$Utils.formatDate(form.end_time),
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);

      if (form.start_time == "") {
        this.$Utils.showTipInfo("請選擇起始時間");
      } else if (form.end_time == "") {
        this.$Utils.showTipInfo("請選擇結束時間");
      } else {
        this.getList();
        window.open(`${this.$Api.inorderex}?${formatParams}`, "_blank");
        // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
      }
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;
      this.$Rq
        .requestAuth({
          url: this.$Api.inorder,
          method: "get",
          data: {
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            start_time: this.$Utils.formatDate(form.start_time),
            end_time: this.$Utils.formatDate(form.end_time),
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let resData = res.data.data;
            this.totalCount = res.data.count;
            this.table.data = resData;
          }
        })
        .catch((err) => {
          // this.isLoading = false;
          this.isSubmiting = false;
        });
    },

    handleSearch() {
      let different_time = this.$Utils.differenttDate(
        this.form.start_time,
        this.form.end_time
      );

      if (this.form.start_time === "") {
        this.$Utils.showTipInfo("請輸入起始時間");
        return;
      } else if (this.form.end_time === "") {
        this.$Utils.showTipInfo("請輸入結束時間");
        return;
      }
      /*else if (this.form.end_time < this.form.start_time ) {
        this.$Utils.showTipInfo('起始時間不能大於結束時間');
        return;
      } else if (different_time > 7){
        this.$Utils.showTipInfo('起始時間加結束時間大過7日');
        return;
      }*/
      this.pageIndex = 1;
      this.getList();
    },

    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },

    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },

    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "forecast.scss";
</style>
